import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  const breadcrumbNameMap = {
    '/': 'Home',
    '/releases': 'Latest Releases',
    '/videos': 'Music Videos',
    '/about-songs': 'Song Stories',
    '/about-me': 'About Exlo',
    '/media': 'Media Features'
  };

  if (pathnames.length === 0) {
    return null; // Don't show breadcrumb on home page
  }

  return (
    <nav className="bg-[#16213e] px-4 py-2 border-b border-[#e94560]" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2 text-sm max-w-6xl mx-auto">
        <li>
          <Link 
            to="/" 
            className="text-cyan-400 hover:text-cyan-300 transition-colors"
            aria-label="Home"
          >
            Home
          </Link>
        </li>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          
          return (
            <li key={name} className="flex items-center">
              <span className="text-gray-400 mx-2">/</span>
              {isLast ? (
                <span className="text-white font-medium" aria-current="page">
                  {breadcrumbNameMap[routeTo] || name}
                </span>
              ) : (
                <Link 
                  to={routeTo} 
                  className="text-cyan-400 hover:text-cyan-300 transition-colors"
                >
                  {breadcrumbNameMap[routeTo] || name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
